import './styles.scss'

import I18n from 'lib/i18n'
import React from 'react'
import { useActions, useValues } from 'kea'

import filtersLogic from '~/scenes/search/filters-page/logic'

export default function SearchWithin () {
  const { unsavedFilter } = useValues(filtersLogic)
  const { updateUnsavedFilter } = useActions(filtersLogic)

  return (
    <div className='filter-section'>
      <div className='filter-title'>{I18n.t('react.search.all_filters.search_within')}</div>
      <div className='input-search-filter'>
        <input
          type='text'
          className='input-text search-within-filter-input'
          value={unsavedFilter.search}
          onChange={e => updateUnsavedFilter({ search: e.target.value })}
        />
      </div>
    </div>
  )
}
